import { Injectable } from '@angular/core';
import { $localize } from '@angular/localize/init';
import { Map } from 'immutable';

import { AccessConsumerItemEntity } from './access-consumer-item.entity';
import { AccessConsumerListEntity } from './access-consumer-list.entity';

export enum ConsumerType {
	User = 'user',
	Group = 'group',
}

@Injectable()
export class AccessConsumerMappingPopupProvider {
	private readonly userList: AccessConsumerListEntity;
	private readonly groupList: AccessConsumerListEntity;

	public constructor() {
		this.userList = AccessConsumerListEntity.build([
			{
				field: 'name',
				alias: '',
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: false,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
			},
			{
				field: 'firstName',
				alias: $localize`:i18n=@@exposition.access.availableConsumers.list.column.firstname:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 1,
			},
			{
				field: 'lastName',
				alias: $localize`:i18n=@@exposition.access.availableConsumers.list.column.lastname:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 2,
			},
			{
				field: 'mail',
				alias: $localize`:i18n=@@exposition.access.availableConsumers.list.column.email:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 3,
			},
		]);
		this.groupList = AccessConsumerListEntity.build([
			{
				field: 'name',
				alias: $localize`:i18n=@@exposition.access.availableConsumers.list.column.name:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@exposition.access.availableConsumers.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 1,
			},
		]);
	}

	public getList(type: ConsumerType): AccessConsumerListEntity {
		return type === 'user' ? this.userList : this.groupList;
	}

	public setListElements(
		type: ConsumerType,
		elements: Map<string, AccessConsumerItemEntity>
	): AccessConsumerListEntity {
		if (type === ConsumerType.User) {
			return this.userList.setMemberListData(elements);
		}
		return this.groupList.setMemberListData(elements);
	}
}
